import { defineStore, createPinia, Pinia } from 'pinia';

/**
 * Global {@link Pinia} instance shared between multiple applications
 */
export const pinia: Pinia = createPinia();

export const useStore = defineStore({
  id: 'root',

  state() {
    return {
      message: 'root',
    };
  },

  actions: {
    changeMessage(message: string): Promise<string> {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.message = message;
          resolve(message);
        }, 3000);
      });
    },
  },
});
